import React from 'react';
import './button.css';

function Button({
  onClick,
  disabled,
  className = '',
  label,
  xl = false,
  flex = false,
}) {
  return (
    <button
      type="button"
      className={`io-button ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

Button.displayName = 'IOButton';
export default Button;
